// Port of api/fuel/app/classes/controller/api/monty/app/syncs.php
export default function() {
	return Promise.resolve({
		body: '\n\t\t\t\t<p>Geekgroup works by caching your BGG data so it can use its own filtering and analytics engine to provide lots of powerful features.</p>\n\t\t\t\t<p>As a result, the BGG data shown is not live and is instead synchronised automatically either monthly, weekly, or daily depending on user.</p>\n\t\t\t\t<p>Every username is updated at least once per month, but if you register your username for free then it will be updated every week. A registered user can also choose which day of the week their sync is on. </p>\n\t\t\t\t<p>Patreons who support the website are updated daily and can even trigger updates themselves.</p>\n\t\t\t',
		questions: [
			{
				question: 'Can I choose when my automated syncs happen?',
				answer: '<p>Yes, <b>registered users</b> can pick which day and Patreons can pick which hourly slot. The system always gives priority to registered users over non-registered.</p>'
			},
			{
				question: 'Can I run a sync whenever I want to?',
				answer: '<p>Only <b>Patreons</b> can run syncs whether they choose. You can find out more about being a Patreon <a href="https://geekgroup.app/community/patreon" target="_blank">here</a>.</p>'
			},
			{
				question: 'Why are some of my old plays missing?',
				answer: '<p>Only recent plays are automatically synced to save time. If you have added or updated older plays you will need to tell geekgroup to run a <b>Full Re-sync</b> next time it syncs. This will re-sync your entire play history and fix any missing or outdated entries.</p>'
			}
		]
	})
}
